import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getGlobalCookie } from "../utils";
import appConfig from "../config";

export default function AuthSyncProvider({ children }) {
  const navigate = useNavigate();
  const initialAccessRef = useRef(JSON.parse(getGlobalCookie("lessorAccess")));

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState !== "visible") return;

      const currentAccess = JSON.parse(getGlobalCookie("lessorAccess"));

      if (!currentAccess) {
        window.location.href = `${appConfig.domain.subDomian}login`;
        return;
      }

      if (
        initialAccessRef.current &&
        currentAccess.id !== initialAccessRef.current.id
      ) {
        navigate("/leases", { replace: true });
        window.location.reload();
      }
    };

    window.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [navigate]);

  return children;
}